import { Checkbox } from "./ui/Checkbox";
import { cn } from "../../utils/cn";
import { useConnector } from "react-instantsearch";
import { useMemo } from "react";
import connectNumericMenu from "instantsearch.js/es/connectors/numeric-menu/connectNumericMenu";

export type InStockFilterProps = {
    className: string,
    children: any,
    attribute: string,
    min: number, // Minimum value for the filter
};

function useNumericMenuConnector(props: { attribute: string, items: Array<{ label: string, start?: number, end?: number }> }) {
    return useConnector(connectNumericMenu, props);
}

export default function InStockFilter({ className, children, attribute, min }: InStockFilterProps) {
    const items = useMemo(() => [
        { label: 'all', start: undefined, end: undefined },
        { label: 'inStock', start: min, end: undefined }
    ], [min]);

    const { items: menuItems, refine, canRefine } = useNumericMenuConnector({
        attribute,
        items
    });

    // Find both options
    const allItem = menuItems.find(item => item.label === 'all');
    const inStockItem = menuItems.find(item => item.label === 'inStock');
    const isRefined = inStockItem?.isRefined || false;

    const handleToggle = () => {
        if (isRefined && allItem) {
            // If currently showing in-stock items, switch to show all
            refine(allItem.value);
        } else if (inStockItem) {
            // If showing all items, switch to show only in-stock
            refine(inStockItem.value);
        }
    };

    return (
        <label className={cn(className)}>
            {children}

            <Checkbox
                checked={isRefined}
                onCheckedChange={handleToggle}
                className="tw-h-4 tw-w-4 tw-border-black tw-text-white tw-mr-2"
            />
        </label>
    );
}
